"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var HelpDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm-.929 13.245l.005.18h1.886l.003-.182c.012-.627.055-1.077.126-1.343.071-.264.18-.495.325-.696.149-.206.48-.54.988-.994.786-.7 1.316-1.3 1.593-1.801.28-.509.42-1.064.42-1.665 0-1.037-.398-1.926-1.19-2.655C14.439 5.362 13.385 5 12.077 5c-1.238 0-2.242.338-3.004 1.016-.763.679-1.22 1.652-1.372 2.91l-.022.184 1.99.239.028-.176c.136-.87.416-1.5.836-1.896.419-.394.939-.59 1.57-.59.653 0 1.2.217 1.647.655.448.437.668.937.668 1.509 0 .312-.074.598-.223.86-.152.269-.498.646-1.034 1.123-.557.495-.944.873-1.163 1.137-.301.366-.52.73-.658 1.094-.185.478-.277 1.044-.277 1.694 0 .109.003.27.01.486zm-.114 2.244v2.01h2.073v-2.01h-2.073z"
  }));
});
HelpDefaultIcon.category = 'Communication';
var _default = HelpDefaultIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/HelpDefaultIcon.js
// module id = 1090
// module chunks = 0